<template>
    <v-switch
            :disabled="item.state !== 'PC'"
            class="mt-0"
            v-model="item.finished"
            :label="item.finished ? $t('button.finished') : $t('button.unfinished')"
            @change="finish"
            inset
            color="green"
    ></v-switch>
</template>

<script>
    import axios from "axios";

    export default {
        props: {
            item: Object
        },
        name: "FinishFormSwitch",
        methods: {
            finish() {
                let path;
                let textSuccess;
                let textError;
                let form_trname = `forms.titles.${this.item.form_name}`
                if(this.item.finished){
                    path = this.$store.state.endpoint + "/moderatedOperations/finish/"+ this.item.object_type + "/" +
                        this.$route.params.id;
                    textSuccess = this.$t('forms.finish', [this.$t(form_trname)])
                    textError = this.$t('error.form.finish.' + this.item.form_name)
                }else{
                    path = this.$store.state.endpoint + "/moderatedOperations/resume/"+ this.item.object_type + "/" +
                        this.$route.params.id;
                    textSuccess = this.$t('forms.resume', [this.$t(form_trname)])
                    textError = this.$t('error.form.resume.' + this.item.form_name)
                }
                axios
                    .patch(path)
                    .then(response => {
                        this.$store.commit("alert", {
                            color: "success",
                            text: textSuccess
                        });
                        this.item.finished = response.data.finished
                    })
                    .catch(error => {
                        console.log(error);
                        this.$store.commit("alert", {
                            color: "error",
                            text: error.response.data
                        });
                    });
            },
        }
    }
</script>

<style scoped>

</style>
